export default "__VITE_ASSET__DxlbBhOi__"